//
// Notification for succeess deposit
// ---------------------------------

define(function(require, exports, module) {
    'use strict';
    var BonusMultiviewBonusCollection = require('portlets/bonus-multiview/bonusmultiview.bonus.collection');
    var config = require('config');

    module.exports = {
        notify: function() {
            var collection = new BonusMultiviewBonusCollection(null, {showAll: true});

            // Buy-in overlay
            if (config.get('bonusManagementPreferences.buyInAfterDeposit')) {
                collection.fetch({bonusTypes: ['buyIn']}).done(function() {
                    var model = collection.find(function(item) {
                        return item.get('type') === 'buyIn';
                    });

                    if (model) {
                        Playtech.API.popup.showPopup('bonusBuyIn', {
                            title: model.get('title'),
                            buyInWebContentId: model.get('buyInWebContentId'),
                            bonusCode: model.get('bonusCode'),
                            termAndConditionWebContentId: model.get('termAndConditionWebContentId')
                        });
                    }
                });
            }

            return this;
        }
    };
});
